import Table from '@components/modules/Table'
import React from 'react'
import columns from './config/columns'
import useMemberSalonsTable from './hooks/useMemberSalonsTable'

export default function MemberSalonsTable({ member }: Props) {
    const options = useMemberSalonsTable()
    
    return <Table data={member.salons} columns={columns} options={options} />
}

interface Props {
    member: Club.Resources.Membership
}